import React, { useEffect } from "react";

import shopPositionIcon from "../../assets/shop-position-icon.png";
import shopPositionMarker from '../../assets/shop-position-marker.png';
import pickupPositionIcon from "../../assets/pickup-position-icon.png";
import returnPositionIcon from "../../assets/return-position-icon.png";
import vehicleMarker from "../../assets/vehicle-marker.png";

type Props = {
  __map__?: any;
  __amapui__?: any;
  driverPosition?: {
    lng?: any;
    lat?: any;
    angle?: any;
  };
  shopPosition?: {
    lng?: any;
    lat?: any;
  };
  userPosition?: {
    lng?: any;
    lat?: any;
  };
  type: string;
  isShopPosition: boolean; //true为门店，false为司机位置
};
export default (props: Props) => {
  const {
    __map__,
    driverPosition,
    shopPosition,
    userPosition,
    type,
    isShopPosition,
  } = props;

  useEffect(() => {
    __map__.clearMap();

    // __map__.setFeatures(['road']);
    // __map__.setMapStyle('amap://styles/whitesmoke');

    let markerDriver;
    if (driverPosition && driverPosition.lng && driverPosition.lat) {
      markerDriver = new window.AMap.Marker({
        position: new window.AMap.LngLat(
          driverPosition.lng,
          driverPosition.lat
        ),
        title: "取车司机位置",
        angle: driverPosition.angle,
        icon: new window.AMap.Icon({
          imageSize: new AMap.Size(18, 31),
          image: vehicleMarker,
        }),
      });

      __map__.add(markerDriver);
    }

    let markerShop;
    if (shopPosition && shopPosition.lng && shopPosition.lat) {
      markerShop = new window.AMap.Marker({
        position: new window.AMap.LngLat(shopPosition.lng, shopPosition.lat),
        title: "服务网点位置",
        icon: new window.AMap.Icon({
          size: new AMap.Size(50, 53),
          imageSize: new AMap.Size(50, 53),
          image: shopPositionMarker,
        }),
      });

      __map__.add(markerShop);
    }
    let markerUser;
    if (userPosition && userPosition.lng && userPosition.lat) {
      markerUser = new window.AMap.Marker({
        position: new window.AMap.LngLat(userPosition.lng, userPosition.lat),
        title: "取还车位置",
        icon: new window.AMap.Icon({
          size: new AMap.Size(73, 33),
          imageSize: new AMap.Size(73, 33),
          image:
            type === "pickup"
              ? pickupPositionIcon
              : type === "return"
              ? returnPositionIcon
              : "",
        }),
      });

      __map__.add(markerUser);
    }
    // isShopPosition控制是否展示门店
    if (isShopPosition) {
      if (markerShop) {
        var curVehicleLngLat = markerShop.getPosition();
        __map__.setCenter(curVehicleLngLat);
        __map__.setZoom(12);
      }
      // __map__.setFitView();
    } else {
      // 如果司机位置有
      if (markerDriver) {
        var curVehicleLngLat = markerDriver.getPosition();
        __map__.setCenter(curVehicleLngLat);
        __map__.setZoom(12);
      } else if (markerUser) {
        var curVehicleLngLat = markerUser.getPosition();
        __map__.setCenter(curVehicleLngLat);
        __map__.setZoom(12);
      }
    }
  });

  return null;
};
